import { GmailPostmasterRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function AnalysisGmailPostmasterRoute() {
  const { workspaceId } = Route.useParams();
  return <GmailPostmasterRoute segment="analysis" workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/analysis/gmail-postmaster')({
  component: AnalysisGmailPostmasterRoute,
});
